import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, Button } from 'antd';
import { getScolarite, deleteScolarite } from './scolarite.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ScolariteDeleteModal = (props: RouteComponentProps<{ id: string }>) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const dispatch = useAppDispatch();
  const scolarite = useAppSelector(state => state.scolarite.entity);
  const scolariteId = props.match.params.id;

  const showModal = () => {
    setIsModalVisible(true);
  };
  useEffect(() => {
    dispatch(getScolarite(scolariteId));
  }, []);

  const handleClose = event => {
    event.stopPropagation();
    props.history.push(`/scolarite/${scolarite.ecoleId}/${scolarite.anneeScolaireId}`);
  };

  const confirmDelete = event => {
    dispatch(deleteScolarite(scolarite.id));
    handleClose(event);
  };

  const goBack = () => {
    props.history.goBack();
  };

  return (
    <Modal
      title="Confirmation de suppression"
      centered
      footer={[
        <Button key="back" onClick={goBack}>
          Annuler
        </Button>,
        <Button key="submit" style={{ backgroundColor: '#cd201f', color: 'white' }} onClick={confirmDelete}>
          Supprimer
        </Button>,
      ]}
      visible={true}
      closable={false}
    >
      Etes-vous certain de vouloir supprimer la scolarité {`${scolarite.mois} ${scolarite.annee}`} ?
    </Modal>
  );
};

export default ScolariteDeleteModal;
